'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
* get the URL of the currently executing Icarus script
*/
var getScriptURL = exports.getScriptURL = function getScriptURL() {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1].src;
};

/**
* get the URL of the parent path of the given URL
* @param url
*/
var getParentPathURL = exports.getParentPathURL = function getParentPathURL(url) {
    var parts = url.split('/');

    if (parts[parts.length - 1] === '') return undefined; // we're at the root already

    return parts.slice(0, parts.length - 1).join('/') + '/';
};

var getElementWidth = exports.getElementWidth = function getElementWidth(el) {
    return el.getBoundingClientRect().width;
};

var getElementHeight = exports.getElementHeight = function getElementHeight(el) {
    return el.getBoundingClientRect().height;
};

/**
 * given a fields array like ["id", "name", ["fields", ["id", "name", ["layout", ["topLeft", "topRight"]]]]], convert
 * that to its representative graphQL string. In this case:
 * {
 *   id,
 *   name,
 *   fields {
 *     id,
 *     name,
 *     layout {
 *       topLeft,
 *       topRight
*      }
*    }
*  }
 * @param fields
 * @return @{String}
 */
var getAsGraphQL = exports.getAsGraphQL = function getAsGraphQL(fields) {
    var graphql = '{';

    fields.forEach(function (f) {
        if (typeof f === 'string') {
            graphql += f + ',';
        } else if (Array.isArray(f)) {
            graphql += '' + f[0] + getAsGraphQL(f[1]);
        } else {
            throw new Error(f + ' must be a string or array');
        }
    });

    graphql = graphql.replace(/(,$)/g, '');

    graphql += '}';

    return graphql;
};


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/lib/utils.js
// module id = 198
// module chunks = 2 3